import { render, staticRenderFns } from "./floatButton.vue?vue&type=template&id=579850c5&scoped=true"
import script from "./floatButton.vue?vue&type=script&lang=js"
export * from "./floatButton.vue?vue&type=script&lang=js"
import style0 from "./floatButton.vue?vue&type=style&index=0&id=579850c5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579850c5",
  null
  
)

export default component.exports